// Pricing data
export interface PricingTier {
  value: string;
  label: string;
  monthly: number | null;
  annual: number | null;
  storage: string;
  custom?: boolean;
  popular?: boolean;
  yearlySalePrice?: number;
  automatedValue?: string;
}

export const automatedPriceMonthly = {
  "200": { price: 49, webinars: 2, storage: "2 GB" },
  "500": { price: 79, webinars: 2, storage: "5 GB" },
  "3000": { price: 143, webinars: 4, storage: "10 GB" },
  "6000": { price: 242, webinars: 4, storage: "10 GB" },
  "10000": { price: 396, webinars: 6, storage: "10 GB" },
  "10000+": { price: "**", webinars: "6+", storage: "Custom" },
};

export const automatedPriceYearly = {
  "200": { price: 41, webinars: 2, storage: "2 GB" },
  "500": { price: 66, webinars: 2, storage: "5 GB" },
  "3000": { price: 119, webinars: 4, storage: "10 GB" },
  "6000": { price: 201, webinars: 4, storage: "10 GB" },
  "10000": { price: 330, webinars: 6, storage: "10 GB" },
  "10000+": { price: "**", webinars: "6+", storage: "Custom" },
};

export const allInOnePriceMonthly = {
  "100": { price: 116, webinars: 3, storage: "2 GB" },
  "300": { price: 198, webinars: 3, storage: "5 GB" },
  "1000": { price: 396, webinars: 3, storage: "10 GB" },
  "3000": { price: 299, webinars: 6, storage: "10 GB" },
  "6000": { price: 449, webinars: 6, storage: "10 GB" },
  "6000+": { price: "**", webinars: "6+", storage: "Custom" },
};

export const allInOnePriceYearly = {
  "100": { price: 96, webinars: 3, storage: "2 GB" },
  "300": { price: 165, webinars: 3, storage: "5 GB" },
  "1000": { price: 330, webinars: 3, storage: "10 GB" },
  "3000": { price: 249, webinars: 6, storage: "10 GB" },
  "6000": { price: 374, webinars: 6, storage: "10 GB" },
  "6000+": { price: "**", webinars: "6+", storage: "Custom" },
};

export const LIVE_PRICES: PricingTier[] = [
  {
    value: "50",
    label: "50 Attendees",
    monthly: 44,
    annual: 36,
    yearlySalePrice: 44,
    storage: "2GB",
  },
];

export const AUTOMATED_PRICES: PricingTier[] = [
  {
    value: "3000",
    label: "3000 Attendees",
    monthly: 144,
    annual: 119,
    yearlySalePrice: 144,
    storage: "10GB",
  },
  {
    value: "6000",
    label: "6000 Attendees",
    monthly: 242,
    annual: 201,
    yearlySalePrice: 242,
    storage: "10GB",
  },
  {
    value: "10000",
    label: "10000 Attendees",
    monthly: 396,
    annual: 330,
    yearlySalePrice: 396,
    storage: "10GB",
  },
];

export const LIVE_AUTO_PRICES: PricingTier[] = [
  {
    value: "200",
    automatedValue: "1000",
    label: "50 Live & 200 Automated",
    monthly: 116,
    annual: 96,
    yearlySalePrice: 116,
    storage: "2GB",
  },
  {
    value: "500",
    automatedValue: "2500",
    label: "250 Live & 500 Automated",
    monthly: 198,
    annual: 165,
    yearlySalePrice: 198,
    storage: "5GB",
  },
  {
    value: "1000",
    automatedValue: "5000",
    label: "500 Live & 3,000 Automated",
    monthly: 396,
    annual: 330,
    yearlySalePrice: 396,
    storage: "10GB",
    popular: true,
  },
];

// ======================= new pricing data =======================

export interface IPricingAddon {
  id: string;
  title: string;
  description: string;
  price: number;
  chargeIdmonthly: string;
  chargeIdYearly: string;
}

export const PricingAddons: IPricingAddon[] = [
  {
    id: "easycrm",
    title: "EasyCRM",
    description: "Complete CRM & automation",
    price: 49,
    chargeIdmonthly: "EasyCRM-USD-Monthly",
    chargeIdYearly: "EasyCRM-USD-Yearly",
  },
  {
    id: "paidwebinars",
    title: "Paid Webinars",
    description: "Monetize your webinars",
    price: 49,
    chargeIdmonthly: "Paid-Webinar-USD-Monthly",
    chargeIdYearly: "Paid-Webinar-USD-Yearly",
  },
];

interface PriceInfo {
  planName: string;
  monthly: number;
  annualPlanPerMonth: number;
  annualMaxPrice: number;
  offPercent?: number;
  /** Display savings amount per year when yearly (e.g. Save $1,572) */
  savingsAmount?: number;
  addons?: string[];
  liveAttendees?: number;
  attendees?: number;
  automatedAttendees?: number;
  MonthlyPlanID?: string;
  YearlyPlanID?: string;
}

export interface AllInOnePrices {
  events: Record<"50" | "200" | "500" | number, PriceInfo>;
  funnels: Record<"3000" | "6000" | "10000" | number, PriceInfo>;
}
export const ALL_IN_ONE_PRICES: AllInOnePrices = {
  events: {
    "50": {
      planName: "Launch",
      monthly: 44,
      annualPlanPerMonth: 36,
      annualMaxPrice: 44,
      savingsAmount: 96,
      addons: [],
      liveAttendees: 50,
      automatedAttendees: 0,
      MonthlyPlanID: "Live-Webinars-USD-Monthly-50",
      YearlyPlanID: "Live-Webinars-USD-Yearly-50",
    },
    "200": {
      planName: "Pro",
      monthly: 116,
      annualPlanPerMonth: 96,
      annualMaxPrice: 214,
      offPercent: 55,
      savingsAmount: 1416,
      addons: ["easycrm", "paidwebinars"],
      liveAttendees: 200,
      automatedAttendees: 1000,
      MonthlyPlanID: "All-In-One-USD-Monthly-200",
      YearlyPlanID: "All-In-One-USD-Yearly-200",
    },
    "500": {
      planName: "Growth",
      monthly: 198,
      annualPlanPerMonth: 165,
      annualMaxPrice: 296,
      offPercent: 44,
      savingsAmount: 1572,
      addons: ["easycrm", "paidwebinars"],
      liveAttendees: 500,
      automatedAttendees: 2500,
      MonthlyPlanID: "All-In-One-USD-Monthly-500",
      YearlyPlanID: "All-In-One-USD-Yearly-500",
    },
  },
  funnels: {
    "3000": {
      planName: "Launch",
      monthly: 144,
      annualPlanPerMonth: 120,
      annualMaxPrice: 242,
      savingsAmount: 1464,
      addons: ["easycrm", "paidwebinars"],
      automatedAttendees: 3000,
      MonthlyPlanID: "Automated-Gold-USD-Monthly-3000",
      YearlyPlanID: "Automated-Gold-USD-Yearly-3000",
    },
    "6000": {
      planName: "Pro",
      monthly: 242,
      annualPlanPerMonth: 201,
      annualMaxPrice: 340,
      savingsAmount: 1668,
      addons: ["easycrm", "paidwebinars"],
      automatedAttendees: 6000,
      MonthlyPlanID: "Automated-Gold-USD-Monthly-6000",
      YearlyPlanID: "Automated-Gold-USD-Yearly-6000",
    },  
    "10000": {
      planName: "Growth",
      monthly: 396,
      annualPlanPerMonth: 330,
      annualMaxPrice: 494,
      savingsAmount: 1968,
      addons: ["easycrm", "paidwebinars"],
      automatedAttendees: 10000,
      MonthlyPlanID: "Automated-Gold-USD-Monthly-10000",
      YearlyPlanID: "Automated-Gold-USD-Yearly-10000",
    },
  },
};

export const PRICING_GHLEvent: AllInOnePrices = {
  events: {
    "50": {
      planName: "Launch",
      monthly: 44,
      annualPlanPerMonth: 44,
      annualMaxPrice: 44,
      savingsAmount: 96,
      addons: [],
      liveAttendees: 50,
      automatedAttendees: 0,
      MonthlyPlanID: "Live-Webinars-USD-Monthly-50",
      YearlyPlanID: "Live-Webinars-USD-Yearly-50",
    },
    "200": {
      planName: "Pro",
      monthly: 116,
      annualPlanPerMonth: 116,
      annualMaxPrice: 214,
      offPercent: 55,
      savingsAmount: 1416,
      addons: [],
      liveAttendees: 200,
      automatedAttendees: 1000,
      MonthlyPlanID: "All-In-One-USD-Monthly-200",
      YearlyPlanID: "All-In-One-USD-Yearly-200",
    },
    "500": {
      planName: "Growth",
      monthly: 198,
      annualPlanPerMonth: 198,
      annualMaxPrice: 296,
      offPercent: 44,
      savingsAmount: 1572,
      addons: [],
      liveAttendees: 500,
      automatedAttendees: 2500,
      MonthlyPlanID: "All-In-One-USD-Monthly-500",
      YearlyPlanID: "All-In-One-USD-Yearly-500",
    },
  },
  funnels: {
    "3000": {
      planName: "Launch",
      monthly: 144,
      annualPlanPerMonth: 144,
      annualMaxPrice: 242,
      savingsAmount: 1464,
      addons: [],
      automatedAttendees: 3000,
      MonthlyPlanID: "Automated-Gold-USD-Monthly-3000",
      YearlyPlanID: "Automated-Gold-USD-Yearly-3000",
    },
    "6000": {
      planName: "Pro",
      monthly: 242,
      annualPlanPerMonth: 242,
      annualMaxPrice: 340,
      savingsAmount: 1668,
      addons: [],
      automatedAttendees: 6000,
      MonthlyPlanID: "Automated-Gold-USD-Monthly-6000",
      YearlyPlanID: "Automated-Gold-USD-Yearly-6000",
    },  
    "10000": {
      planName: "Growth",
      monthly: 396,
      annualPlanPerMonth: 396,
      annualMaxPrice: 494,
      savingsAmount: 1968,
      addons: [],
      automatedAttendees: 10000,
      MonthlyPlanID: "Automated-Gold-USD-Monthly-10000",
      YearlyPlanID: "Automated-Gold-USD-Yearly-10000",
    },
  },
};


const SIGNUP_PLANS: Record<string, PriceInfo> = {
  LAUNCH_50:{
    planName: "Launch",
    monthly: 44,
    annualPlanPerMonth: 36,
    annualMaxPrice: 44,
    savingsAmount: 96,
    addons: [],
    liveAttendees: 50,
    automatedAttendees: 0,
    MonthlyPlanID: "Live-Webinars-USD-Monthly-50",
    YearlyPlanID: "Live-Webinars-USD-Yearly-50",
  },
  PRO_200: {
    planName: "Pro",
    monthly: 116,
    annualPlanPerMonth: 96,
    annualMaxPrice: 116,
    offPercent: 55,
    savingsAmount: 240,
    addons: ["easycrm", "paidwebinars"],
    liveAttendees: 200,
    automatedAttendees: 1000,
    MonthlyPlanID: "All-In-One-USD-Monthly-200",
    YearlyPlanID: "All-In-One-USD-Yearly-200",
  },
  PRO_500: {
    planName: "Pro",
    monthly: 198,
    annualPlanPerMonth: 165,
    annualMaxPrice: 198,
    offPercent: 44,
    savingsAmount: 396,
    addons: ["easycrm", "paidwebinars"],
    liveAttendees: 500,
    automatedAttendees: 2500,
    MonthlyPlanID: "All-In-One-USD-Monthly-500",
    YearlyPlanID: "All-In-One-USD-Yearly-500",
  },
  PRO_1000: {
    planName: "Pro",
    monthly: 349,
    annualPlanPerMonth: 291,
    annualMaxPrice: 349,
    savingsAmount: 696,
    addons: ["easycrm", "paidwebinars"],
    liveAttendees: 1000,
    automatedAttendees: 5000,
    MonthlyPlanID: "All-In-One-USD-Monthly-1000",
    YearlyPlanID: "All-In-One-USD-Yearly-1000",
  },
  AUTOMATED_GOLD_3000: {
    planName: "Launch",
    monthly: 144,
    annualPlanPerMonth: 144,
    annualMaxPrice: 242,
    savingsAmount: 1464,
    addons: ['easycrm', 'paidwebinars'],
    automatedAttendees: 3000,
    MonthlyPlanID: "Automated-Gold-USD-Monthly-3000",
    YearlyPlanID: "Automated-Gold-USD-Yearly-3000",
  },
  AUTOMATED_GOLD_6000: {
    planName: "Pro",
    monthly: 242,
    annualPlanPerMonth: 242,
    annualMaxPrice: 340,
    savingsAmount: 1668,
    addons: ['easycrm', 'paidwebinars'],
    automatedAttendees: 6000,
    MonthlyPlanID: "Automated-Gold-USD-Monthly-6000",
    YearlyPlanID: "Automated-Gold-USD-Yearly-6000",
  },
  AUTOMATED_GOLD_10000: {
    planName: "Growth",
    monthly: 396,
    annualPlanPerMonth: 396,
    annualMaxPrice: 494,
    savingsAmount: 1968,
    addons: ['easycrm', 'paidwebinars'],
    automatedAttendees: 10000,
    MonthlyPlanID: "Automated-Gold-USD-Monthly-10000",
    YearlyPlanID: "Automated-Gold-USD-Yearly-10000",
  },
  Agency_Bundle: {
    planName: "Agency Bundle",
    monthly: 399,
    annualPlanPerMonth: 333,
    annualMaxPrice: 399,
    savingsAmount: 792,
    addons: ['easycrm', 'paidwebinars'],
    liveAttendees: 1000,
    MonthlyPlanID: "Agency-Bundle-USD-Monthly-1000",
    YearlyPlanID: "Agency-Bundle-USD-Yearly-1000",
  }
}

export const ALL_SIGNUP_PLANS: Record<string, PriceInfo> = {
  "Live-Webinars-USD-Monthly-50": SIGNUP_PLANS.LAUNCH_50,
  "Live-Webinars-USD-Yearly-50": SIGNUP_PLANS.LAUNCH_50,

  "All-In-One-USD-Monthly-200": SIGNUP_PLANS.PRO_200,
  "All-In-One-USD-Yearly-200": SIGNUP_PLANS.PRO_200,

  "All-In-One-USD-Monthly-500": SIGNUP_PLANS.PRO_500,
  "All-In-One-USD-Yearly-500": SIGNUP_PLANS.PRO_500,

  "All-In-One-USD-Monthly-1000": SIGNUP_PLANS.PRO_1000,
  "All-In-One-USD-Yearly-1000": SIGNUP_PLANS.PRO_1000,

  "Automated-Gold-USD-Monthly-3000": SIGNUP_PLANS.AUTOMATED_GOLD_3000,
  "Automated-Gold-USD-Yearly-3000": SIGNUP_PLANS.AUTOMATED_GOLD_3000,

  "Automated-Gold-USD-Monthly-6000": SIGNUP_PLANS.AUTOMATED_GOLD_6000,
  "Automated-Gold-USD-Yearly-6000": SIGNUP_PLANS.AUTOMATED_GOLD_6000,

  "Automated-Gold-USD-Monthly-10000": SIGNUP_PLANS.AUTOMATED_GOLD_10000,
  "Automated-Gold-USD-Yearly-10000": SIGNUP_PLANS.AUTOMATED_GOLD_10000,

  "Agency-Bundle-USD-Monthly-1000": SIGNUP_PLANS.Agency_Bundle,
  "Agency-Bundle-USD-Yearly-1000": SIGNUP_PLANS.Agency_Bundle,
};
